import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// icons
import { ExclamationCircleOutlined } from '@ant-design/icons';

function FBSectionErroMessage({ 
  showMessage,
  message,
  // default props
  className
}) {
  const childClassNames = classNames('tcf-fb-group-error', className);
  const { t, i18n } = useTranslation();

  const renderMsg = useMemo(() => (
    <>
      <ExclamationCircleOutlined className="tcf-fb-group-error__icon" />
      <span className="tcf-fb-group-error__message">
        {!!message && message || t("inputs.checkFillingForm")}
      </span>
    </>
  ), [message, showMessage, i18n?.language]);

  return showMessage && (
    <div className={childClassNames}>
      {renderMsg}
    </div>
  );
}

FBSectionErroMessage.defaultProps = {
  showMessage: false
};

export default FBSectionErroMessage;